export default __webpack_public_path__ + "static/media/facebook-circled-shake.39e4e80f.gif";